import Box from '@mui/material/Box';
import { createFileRoute } from '@tanstack/react-router';
import AppHeader from '../features/app-header/AppHeader';
import RecipeView from '../features/recipe/RecipeView';

const SearchComponent = () => {
  return (
    <Box>
      <AppHeader />
      <RecipeView />
    </Box>
  );
};

export const Route = createFileRoute('/recipes')({
  component: SearchComponent,
});
